<div class="bp-modal mod-lg wrapper">
	@switch (verificationStep()) {
		@case (onHoldVerificationStep.Loading) {
			<ng-container [ngTemplateOutlet]="loading"></ng-container>
		}
		@case (onHoldVerificationStep.OnHold) {
			<ng-container [ngTemplateOutlet]="onHold"></ng-container>
		}
		@case (onHoldVerificationStep.ExitWithoutVerifying) {
			<ng-container [ngTemplateOutlet]="exitWithoutVerifying"></ng-container>
		}
		@case (onHoldVerificationStep.VerificationInProgress) {
			<ng-container [ngTemplateOutlet]="verificationInProgress"></ng-container>
		}
		@case (onHoldVerificationStep.ErrorNotCompleted) {
			<ng-container [ngTemplateOutlet]="errorNotCompleted"></ng-container>
		}
		@case (onHoldVerificationStep.ErrorTemporaryUnavailable) {
			<ng-container [ngTemplateOutlet]="errorTemporaryUnavailable"></ng-container>
		}
		@case (onHoldVerificationStep.ErrorFailed) {
			<ng-container [ngTemplateOutlet]="errorFailed"></ng-container>
		}
		@case (onHoldVerificationStep.ErrorPaymentTransactionNotFound) {
			<ng-container [ngTemplateOutlet]="errorPaymentTransactionNotFound"></ng-container>
		}
		@case (onHoldVerificationStep.Success) {
			<ng-container [ngTemplateOutlet]="success"></ng-container>
		}
		@case (onHoldVerificationStep.Notabene) {
			<div class="notabene-header">
				<button type="button" class="btn btn-link font-size-15 font-medium" (click)="backFromNotabene()">
					{{ "back" | translate }}
				</button>
				<button type="button" class="btn btn-link font-size-15 font-medium" (click)="notNow()">
					{{ "close" | translate }}
				</button>
			</div>
		}
	}
	<!-- NOTABENE COMPONENT PLACEHOLDER -->
	<div id="notabene" [hidden]="verificationStep() !== onHoldVerificationStep.Notabene"></div>
</div>

<ng-template #loading>
	<div class="bp-modal-body">
		<div class="bp-modal-description">
			<div class="header">
				<div class="orange-icon loading"></div>
				<h2 class="loading"></h2>
			</div>
		</div>
		<div class="bp-modal-body-section">
			<h2 class="loading"></h2>
			<h1 class="loading"></h1>
		</div>
	</div>

	<div class="footer">
		<button class="btn loading"> </button>
		<button class="btn loading"> </button>
	</div>
</ng-template>

<ng-template #onHold>
	<div class="bp-modal-body">
		<div class="bp-modal-description">
			<div class="header">
				<div class="bpi__icon-info orange-icon"></div>
				@if (verificationAction() === "withdrawal") {
					<h2> {{ "digital_signature_required_withdrawal_title" | translate }} </h2>
				} @else {
					<h2> {{ "digital_signature_required_deposit_title" | translate }} </h2>
				}
			</div>
		</div>
		<div class="bp-modal-body-section">
			<span>
				@if (verificationAction() === "withdrawal") {
					{{
						"digital_signature_required_withdrawal_message"
							| translate: [transactionAmountAndSymbol, walletAddress()]
					}}
				} @else {
					{{
						"digital_signature_required_deposit_message"
							| translate: [transactionAmountAndSymbol, walletAddress()]
					}}
				}
			</span>
		</div>
	</div>

	<div class="footer">
		<button (click)="doItLater()" class="btn btn-primary btn-inverse">
			{{ "digital_signature_cta_do_later" | translate }}
		</button>
		<button (click)="verifyWallet()" class="btn btn-primary"
			>{{ "digital_signature_cta_verify_wallet" | translate }}
		</button>
	</div>
</ng-template>

<ng-template #exitWithoutVerifying>
	<div class="bp-modal-body">
		<div class="bp-modal-description">
			<div class="header">
				<div class="bpi__icon-info orange-icon"></div>
				<h2> {{ "digital_signature_warning_sheet_title" | translate }} </h2>
			</div>
		</div>
		<div class="bp-modal-body-section">
			<p [innerHTML]="warningInput()"></p>
		</div>
	</div>

	<div class="footer">
		<button (click)="notNow()" class="btn btn-primary btn-inverse">{{
			"2fa_enforce_modal_cancel" | translate
		}}</button>
		<button (click)="continueVerification()" class="btn btn-primary">{{
			"digital_signature_warning_sheet_continue" | translate
		}}</button>
	</div>
</ng-template>

<ng-template #success>
	<div class="bp-modal-body">
		<div class="bp-modal-description">
			<div class="header">
				<div class="bpi__icon-info blue-icon"></div>
				<h2> {{ "digital_signature_success_title" | translate }} </h2>
			</div>
		</div>
		<div class="bp-modal-body-section">
			<span>
				@if (verificationAction() === "withdrawal") {
					{{
						"digital_signature_withdrawal_success_message"
							| translate: [walletAddress(), transactionAmountAndSymbol]
					}}
				} @else {
					{{
						"digital_signature_deposit_success_message"
							| translate: [walletAddress(), transactionAmountAndSymbol]
					}}
				}
			</span>
		</div>
	</div>

	<div class="footer">
		<button (click)="goToTransactionHistory()" class="btn btn-primary">{{
			"digital_signature_cta_see_transaction_details" | translate
		}}</button>
	</div>
</ng-template>

<ng-template #verificationInProgress>
	<div class="bp-modal-body">
		<div class="bp-modal-description">
			<div class="header">
				<div class="bpi__icon-info blue-icon"></div>
				<h2> {{ "digital_signature_in_progress_title" | translate }} </h2>
			</div>
		</div>
		<div class="bp-modal-body-section">
			<span>
				@if (verificationAction() === "withdrawal") {
					{{
						"digital_signature_in_progress_withdrawal_message"
							| translate: [walletAddress(), transactionAmountAndSymbol]
					}}
				} @else {
					{{
						"digital_signature_in_progress_deposit_message"
							| translate: [walletAddress(), transactionAmountAndSymbol]
					}}
				}
			</span>
		</div>
	</div>

	<div class="footer">
		<button (click)="goToPortfolio()" class="btn btn-primary">{{
			"digital_signature_cta_go_to_portfolio" | translate
		}}</button>
	</div>
</ng-template>

<ng-template #errorNotCompleted>
	<div class="bp-modal-body">
		<div class="bp-modal-description">
			<div class="header">
				<div class="bpi__icon-info red-icon"></div>
				<h2> {{ "digital_signature_error_not_finished_title" | translate }} </h2>
			</div>
		</div>
		<div class="bp-modal-body-section">
			<span>
				@if (verificationAction() === "withdrawal") {
					{{
						"digital_signature_error_not_finished_withdrawal_message"
							| translate: [walletAddress(), transactionAmountAndSymbol]
					}}
				} @else {
					{{
						"digital_signature_error_not_finished_deposit_message"
							| translate: [walletAddress(), transactionAmountAndSymbol]
					}}
				}
			</span>
		</div>
	</div>

	<div class="footer">
		<button (click)="doItLater()" class="btn btn-primary btn-inverse">
			{{ "digital_signature_cta_do_later" | translate }}
		</button>
		<button (click)="verifyWallet()" class="btn btn-primary">
			{{ "try_again" | translate }}
		</button>
	</div>
</ng-template>

<ng-template #errorTemporaryUnavailable>
	<div class="bp-modal-body">
		<div class="bp-modal-description">
			<div class="header">
				<div class="bpi__icon-info red-icon"></div>
				<h2> {{ "digital_signature_error_sdk_unavailable_title" | translate }} </h2>
			</div>
		</div>
		<div class="bp-modal-body-section">
			<span>
				@if (verificationAction() === "withdrawal") {
					{{
						"digital_signature_error_sdk_unavailable_withdrawal_message"
							| translate: [walletAddress(), transactionAmountAndSymbol]
					}}
				} @else {
					{{
						"digital_signature_error_sdk_unavailable_deposit_message"
							| translate: [walletAddress(), transactionAmountAndSymbol]
					}}
				}
			</span>
		</div>
	</div>

	<div class="footer">
		<button (click)="doItLater()" class="btn btn-primary btn-inverse">
			{{ "digital_signature_cta_do_later" | translate }}
		</button>
		<button (click)="verifyWallet()" class="btn btn-primary">
			{{ "try_again" | translate }}
		</button>
	</div>
</ng-template>

<ng-template #errorFailed>
	<div class="bp-modal-body">
		<div class="bp-modal-description">
			<div class="header">
				<div class="bpi__icon-info red-icon"></div>
				<h2> {{ "digital_signature_failure_title" | translate }} </h2>
			</div>
		</div>
		<div class="bp-modal-body-section">
			<span>
				@if (verificationAction() === "withdrawal") {
					{{
						"digital_signature_error_verification_failed_withdrawal_message"
							| translate: [walletAddress(), transactionAmountAndSymbol]
					}}
				} @else {
					{{
						"digital_signature_error_verification_failed_deposit_message"
							| translate: [walletAddress(), transactionAmountAndSymbol]
					}}
				}
			</span>
		</div>
	</div>

	<div class="footer">
		<button (click)="doItLater()" class="btn btn-primary btn-inverse">
			{{ "digital_signature_cta_do_later" | translate }}
		</button>
		<button (click)="verifyWallet()" class="btn btn-primary">
			{{ "try_again" | translate }}
		</button>
	</div>
</ng-template>

<!-- error payment -->
<ng-template #errorPaymentTransactionNotFound>
	<bp-try-again-error
		[title]="'digital_signature_failure_title' | translate"
		[message]="'assets_loading_error_message' | translate"
		[tryAgainMessage]="'close' | translate"
		[showTryAgainIcon]="false"
		(onRetry)="notNow()"></bp-try-again-error>
</ng-template>
